/**
 * @date 27.09.19
 * @author Martin Gabor
 */

import React from "react";
import axios from "axios";
import { getAuthHttpHeaders } from "../auth";
import Dimensions from "react-dimensions";
import { VictoryChart, VictoryAxis, VictoryBar, VictoryGroup, VictoryTooltip, VictoryTheme } from "victory";
import { Loader } from "semantic-ui-react";

class TradeVolumeChart extends React.Component {
  state = {
    loading: false,
    data: null,
  };

  componentDidMount() {
    this.load(this.props.botId, this.props.exchangeType, this.props.sim);
  }

  async load(botId, exchangeType, sim) {
    this.setState({ loading: true });

    try {
      const axiosRequest = axios.create({
        baseURL: "api",
        timeout: 30 * 1000,
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
        params: {
          botId: botId,
          exchangeType: exchangeType,
          sim: sim,
        },
      });

      const response = await axiosRequest.get("chart/closedTradeVolumes");
      this.setState({ data: this.prepareData(response.data) });
    } catch (e) {
      this.setState({ data: null });
    } finally {
      this.setState({ loading: false });
    }
  }

  prepareData(volumes) {
    const tradeGroups = volumes.reduce((acc, v) => {
      const category = parseInt(v.volume.toFixed(0), 10);

      let groupObject = acc.get(category);
      groupObject = groupObject
        ? groupObject
        : {
            profitCount: 0,
            lossCount: 0,
            ccys: new Set(),
          };

      if (v.profitTotal > 0) {
        groupObject.profitCount += 1;
      } else {
        groupObject.lossCount += 1;
      }
      groupObject.ccys.add(v.currency);

      acc.set(category, groupObject);
      return acc;
    }, new Map());

    const profits = [{ x: 0, y: 0, y0: 0 }];
    const losses = [{ x: 0, y: 0, y0: 0 }];

    tradeGroups.forEach((value, key) => {
      const labelValue = "Volume " + key + "\n\n" + [...value.ccys];

      profits.push({
        x: key,
        y: value ? value.profitCount : 0,
        y0: 0,
        label: labelValue,
      });

      losses.push({
        x: key,
        y: value ? -value.lossCount : 0,
        y0: 0,
        label: labelValue,
      });
    });

    return { profits, losses };
  }

  render() {
    const { data, loading } = this.state;

    if (loading) return <Loader active />;

    if (!data) return null;

    return (
      <VictoryChart width={this.props.containerWidth} height={400} theme={VictoryTheme.material}>
        <VictoryAxis dependentAxis label="Trade count" style={{ axisLabel: { padding: 40 } }} />
        <VictoryAxis label="Volume" scale={{ x: "sqrt" }} />
        <VictoryGroup offset={0} colorScale={["#69D95C", "#f13966"]}>
          <VictoryBar
            data={data.profits}
            labelComponent={<VictoryTooltip dx={-5} />}
            events={[
              {
                target: "data",
                eventHandlers: {
                  onMouseOver: () => {
                    return [
                      {
                        target: "data",
                        mutation: d => ({ style: { fill: d.style.fill } }), // return a new style object without fillOpacity
                      },
                      {
                        target: "labels",
                        mutation: () => ({ active: true }),
                      },
                    ];
                  },
                  onMouseOut: () => {
                    return [
                      {
                        target: "data",
                        mutation: () => {},
                      },
                      {
                        target: "labels",
                        mutation: () => ({ active: false }),
                      },
                    ];
                  },
                },
              },
            ]}
          />
          <VictoryBar
            data={data.losses}
            labelComponent={<VictoryTooltip dx={-5} />}
            events={[
              {
                target: "data",
                eventHandlers: {
                  onMouseOver: () => {
                    return [
                      {
                        target: "data",
                        mutation: d => ({ style: { fill: d.style.fill } }), // return a new style object without fillOpacity
                      },
                      {
                        target: "labels",
                        mutation: () => ({ active: true }),
                      },
                    ];
                  },
                  onMouseOut: () => {
                    return [
                      {
                        target: "data",
                        mutation: () => {},
                      },
                      {
                        target: "labels",
                        mutation: () => ({ active: false }),
                      },
                    ];
                  },
                },
              },
            ]}
          />
        </VictoryGroup>
      </VictoryChart>
    );
  }
}

export default Dimensions()(TradeVolumeChart);



// WEBPACK FOOTER //
// ./src/charts/TradeVolumeChart.js